<mat-toolbar fxLayout="row" fxLayoutAlign="center center" mat-dialog-title>
    <strong>Transfer Stock</strong>
</mat-toolbar>

<form [formGroup]="formGroup" fxFlexFill fxLayout="column" fxLayoutAlign="space-around center" mat-dialog-content>
    <lgd-select controlName="transferFrom" label="From" [options]="locationsObservable" aria-label="Transfer-From-TransferStock-Inventory">
    </lgd-select>

    <lgd-select controlName="transferTo" label="To" [options]="locationsObservable" aria-label="Transfer-To-TransferStock-Inventory">
    </lgd-select>

    <lgd-number controlName="quantity" label="Quantity" telemetry="Edit-Quantity-TransferStock-Inventory">
    </lgd-number>
</form>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end start">
    <command-bar [commands]="commands" telemetry="CmdBar-CommandKey-TransferStock-Inventory"></command-bar>
</div>